export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7faa2548a13fb24d9e3ff2ad4f7cef1c84026cb8b4&name=fetchTypeahead!'